module.exports = __webpack_public_path__ + "img/emoji-42.08257914.png";